import React from 'react';
import { useTranslation } from 'react-i18next';
import { useClient } from '@context/presentation';
import { HighlightSection } from '../styles';

export const SectionTwo = () => {
    const { t } = useTranslation();
    const { firm } = useClient();

    return (
        <>
            <div>{t('we_can_help.script.5')}</div>
            <p><strong>{t('we_can_help.script.ccm')}</strong></p>
            <div>{t('we_can_help.script.ccm_question')}</div>
            <div>
                {t('we_can_help.script.ccm_explanation1')}
                <strong>{firm}</strong>
                {t('we_can_help.script.ccm_explanation2')}
            </div>
            <HighlightSection>
                <strong>{t('we_can_help.script.possible_question1')}</strong>
                {t('we_can_help.script.possible_question2')}
                <p>
                    <strong>{t('we_can_help.script.rebuttal')}</strong>
                    {t('we_can_help.script.rebuttal1')}
                    <strong>{firm}</strong>
                    {t('we_can_help.script.rebuttal2')}
                </p>
            </HighlightSection>
        </>
    );
};

